<template>
  <modal-template
    ref="modal"
    size="md"
    title="Exportar Relatório de Tags"
    type-modal="report_posts_modal"
  >
    <div class="modal-content__main">
      <d-form>

        <d-form-row>
          <!-- Filter Name -->
          <d-col md="12" class="form-group">
            <label>E-mail</label>
            <d-input v-model="model.email" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Conditions -->
          <d-col md="12" class="form-group mb-0">
            <label>Message:</label>
            <editor ref="recibo" :model.sync="model.message"/>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button
        type="button"
        @click="exportCsv()"
        class="btn btn-sm btn-secondary mr-3"
      >Download</d-button>
      <d-button
        type="button"
        @click="send()"
        class="btn btn-sm btn-primary"
      >Enviar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { downloadCsvFile, catchPdf } from '_utils';
import Events from '_utils/events';
import Editor from '_shared/Editor.vue';
import ReportService from '_services/rest/modules/report';
import ModalTemplate from '_shared/Modal.vue';
import { _OPEN_EXPORT_POSTS_MODAL_ } from '../TagModel';

export default {
  name: 'report-posts-modal',
  components: {
    Editor,
    ModalTemplate,
  },
  props: {
    title: {
      type: String,
      default: 'Novo filtro',
    },
  },
  data() {
    return {
      model: {
        email: null,
        message: null,
      },
      pagination: {},
    };
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getFilterList',
      'getTagFilterList',
    ]),
    close() {
      this.setToggle({ type: 'report_posts_modal', bool: false });
    },
    exportCsv() {
      ReportService.exportCsv(this.pagination)
        .then(response => downloadCsvFile(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }));
    },
    send() {
      this.pagination.email = this.model.email;
      this.pagination.message = this.model.message;
      ReportService.sendCsv(this.pagination)
        .then(() => this.activeAlert({ message: 'Enviado com sucesso!', theme: 'success' }))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }));
    },
  },
  mounted() {
    Events.$on(_OPEN_EXPORT_POSTS_MODAL_, pagination => {
      this.pagination = pagination;
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
